import React, { useEffect, useState } from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import LoginPage from './Pages/Acessos/Login/LoginPage';
import GridViagemPage from './Pages/Paineis/GridViagem/GridViagemPage';
import ConePage from './Pages/Paineis/ConeDeRisco/ConePage';
import ConeLogisticoPage from './Pages/Paineis/ConeLogistico/ConeLogisticoPage';
import PainelPowerBIPage from './Pages/Paineis/PainelPowerBI/PainelPowerBIPage';
import EventoLogisticoPage from './Pages/Paineis/EventoLogistico/EventoLogisticoPage';
import ControleDocaPage from './Pages/Paineis/ControleDoca/ControleDocaPage';
import { createTheme, ThemeProvider } from '@mui/material';
import { ConfigProvider, theme } from 'antd';
import RotogramaViagemPage from './Pages/Relatorios/RotogramaViagem/RotogramaViagemPage';
import RotogramaViagemSimplePage from './Pages/Relatorios/RotogramaViagem/RotogramaViagemSimplePage';
import RotogramaViagemPrint from './Pages/Relatorios/RotogramaViagem/RotogramaViagemPrint';
import RotogramaViagemPrintPage from './Pages/Relatorios/RotogramaViagem/RotogramaViagemPrint';

function App() {
  const [darkMode, setDarkMode] = useState(false);
  const [darkModeAnt, setDarkModeAnt] = useState(false);

  const lightTheme = createTheme({
    palette: {
      mode: "light",
    },
  });

  const darkTheme = createTheme({
    palette: {
      mode: "dark",
    },
  });

  const [preferences, setPreferences] = useState<any | null>(() => {
      const storedPreferences = localStorage.getItem("preferences");
      return storedPreferences ? JSON.parse(storedPreferences) : [];
  });

  useEffect(() => {
    let darkMode = preferences == null ? false : (preferences?.darkMode ?? false) ;
    document.documentElement.setAttribute("data-theme", darkMode ? 'dark' : 'light');
    setDarkMode((prevMode) => darkMode);
  }, []);
  
  return (
    <div className="App">
    <ConfigProvider
      theme={{
        algorithm: (darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm)
      }}
    >
      <ThemeProvider theme={darkMode ? darkTheme : lightTheme}>
        <BrowserRouter>
          <Routes>
            <Route path={'/'} element={<GridViagemPage />} />
            <Route path={'/login'} element={<LoginPage />} />
            <Route path={'/coneDeRisco'} element={<ConePage />} />
            <Route path={'/coneLogistico'} element={<ConeLogisticoPage />} />
            <Route path={'/painel'} element={<PainelPowerBIPage />} />
            <Route path={'/painelLogistico'} element={<EventoLogisticoPage />} />
            <Route path={'/controledocas'} element={<ControleDocaPage />} />
            <Route path={'/rotogramaReport/:id'} element={<RotogramaViagemPage />} />
            <Route path={'/rotograma/:id'} element={<RotogramaViagemSimplePage />} />
            <Route path={'/RotogramaViagemPrint/:id'} element={<RotogramaViagemPrintPage />} />

            
          </Routes>
        </BrowserRouter>
        </ThemeProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;